module.exports = __webpack_public_path__ + "assets/img/pr.6531d851.png";